<template>
  <div class="room report-list" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command"></div>
    <el-table :data="tableData" style="width: 100%" :max-height="tableMaxHeight" class="data-source-table">
      <el-table-column align="center" label="序号" type="index" width="50"></el-table-column>

      <el-table-column label="设备组" align="center">
        <el-table-column align="center" prop="stationName" width="110"></el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-tag class="percentage-tag" effect="dark" :type="scope.row.stationTagType">{{ scope.row.stationConnected }}</el-tag>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column label="无线温湿度" align="center">
        <el-table-column align="center" prop="SensorValueDateDisplay" width="135"></el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-tag class="percentage-tag" effect="dark" :type="scope.row.sensorValueTagType">{{ scope.row.sensorValueConnected }}</el-tag>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column label="无线开关" align="center">
        <el-table-column align="center" prop="SensorFlagDateDisplay" width="135"></el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-tag class="percentage-tag" effect="dark" :type="scope.row.sensorFlagTagType">{{ scope.row.sensorFlagConnected }}</el-tag>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column label="有线温湿度与能耗" align="center">
        <el-table-column align="center" prop="CableDateDisplay" width="135"></el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-tag class="percentage-tag" effect="dark" :type="scope.row.cableTagType">{{ scope.row.cableConnected }}</el-tag>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column label="设备组" align="center">
        <el-table-column align="center" prop="stationName2" width="140"></el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-tag class="percentage-tag" effect="dark" :type="scope.row.stationTagType2">{{ scope.row.stationConnected2 }}</el-tag>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column label="无线温湿度" align="center">
        <el-table-column align="center" prop="SensorValueDateDisplay2" width="135"></el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-tag class="percentage-tag" effect="dark" :type="scope.row.sensorValueTagType2">{{ scope.row.sensorValueConnected2 }}</el-tag>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column label="无线开关" align="center">
        <el-table-column align="center" prop="SensorFlagDateDisplay2" width="135"></el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-tag class="percentage-tag" effect="dark" :type="scope.row.sensorFlagTagType2">{{ scope.row.sensorFlagConnected2 }}</el-tag>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column label="有线温湿度与能耗" align="center">
        <el-table-column align="center" prop="CableDateDisplay2" width="135"></el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-tag class="percentage-tag" effect="dark" :type="scope.row.cableTagType2">{{ scope.row.cableConnected2 }}</el-tag>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      ref="page"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  name: "jiashaoDataSourceConnection",
  data() {
    return {
      loadingFullScreen: null,
      timer: null,
      isAdmin: false,
      fullData: [],
      tableData: [],
      userIdUserDict: {},
      bridgeIdBridgeNameDict: null,
      loading: false,
      shownewUser: false,
      checkUserId: "",
      totalCount: 1,
      currentPage: 1,
      pageSize: 16,
      userTranslateDict: {},
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getData();

    this.timer = setInterval(() => {
      this.getData();
    }, 60 * 5 * 1000);

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    },
    createUserDialogVisible(newVal, oldVal) {
      if (newVal) {
        this.$refs.createUserForm.resetFields();
      }
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };
      });
    },
  },
  methods: {
    refreshData() {
      this.getData();
    },
    currentChange(index) {
      this.currentPage = index;
      this.loading = true;
      this.getPageData();
    },
    getPageData() {
      let startIndex = (this.currentPage - 1) * this.pageSize;
      let endIndex = this.currentPage * this.pageSize - 1;

      let dataList = [];
      for (let i = startIndex; i <= endIndex; i++) {
        if (i >= this.fullData.length) {
          break;
        }

        dataList.push(this.fullData[i]);
      }

      this.tableData = dataList;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    getData() {
      this.loading = true;
      this.getDataList();
    },
    getDataList() {
      this.$http.get("/specialAnalyze/JiashaoDataSourceConnection").then((res) => {
        let dataList = res.data;

        for (let dataItem of dataList) {
          if (dataItem.IsDataSourceConnected_SensorValue) {
            dataItem.sensorValueConnected = "正常";
            dataItem.sensorValueTagType = "success";
          } else {
            dataItem.sensorValueConnected = "中断";
            dataItem.sensorValueTagType = "warning";
          }

          if (dataItem.IsDataSourceConnected_SensorFlag) {
            dataItem.sensorFlagConnected = "正常";
            dataItem.sensorFlagTagType = "success";
          } else {
            dataItem.sensorFlagConnected = "中断";
            dataItem.sensorFlagTagType = "warning";
          }

          if (dataItem.IsDataSourceConnected_Cable) {
            dataItem.cableConnected = "正常";
            dataItem.cableTagType = "success";
          } else {
            dataItem.cableConnected = "中断";
            dataItem.cableTagType = "warning";
          }

          if (dataItem.IsDataSourceConnected_SensorValue || dataItem.IsDataSourceConnected_Cable) {
            dataItem.stationConnected = "正常";
            dataItem.stationTagType = "success";
          } else {
            dataItem.stationConnected = "中断";
            dataItem.stationTagType = "warning";
          }

          dataItem.SensorValueDateDisplay = dataItem.SensorValueDateDisplay.slice(3);
          dataItem.SensorFlagDateDisplay = dataItem.SensorFlagDateDisplay.slice(3);
          dataItem.CableDateDisplay = dataItem.CableDateDisplay.slice(3);
        }

        //move RigidHinge J1-J4 in between Tower and Steelbox (after T12 before G1)
        var rigidHingeItem = dataList.splice(28, 4);
        dataList.splice(12, 0, ...rigidHingeItem);

        //merge 2 row into 1
        let dataListMerged = [];
        let dataListMergedCount = Math.floor(dataList.length / 2);
        for (let i = 0; i < dataListMergedCount; i++) {
          let mergedItem = dataList[i];

          if (i + dataListMergedCount <= dataList.length) {
            let mergeTarget = dataList[i + dataListMergedCount];
            mergedItem.stationName2 = mergeTarget.stationName;
            mergedItem.stationTagType2 = mergeTarget.stationTagType;
            mergedItem.stationConnected2 = mergeTarget.stationConnected;

            mergedItem.SensorValueDateDisplay2 = mergeTarget.SensorValueDateDisplay;
            mergedItem.sensorValueTagType2 = mergeTarget.sensorValueTagType;
            mergedItem.sensorValueConnected2 = mergeTarget.sensorValueConnected;

            mergedItem.SensorFlagDateDisplay2 = mergeTarget.SensorFlagDateDisplay;
            mergedItem.sensorFlagTagType2 = mergeTarget.sensorFlagTagType;
            mergedItem.sensorFlagConnected2 = mergeTarget.sensorFlagConnected;

            mergedItem.CableDateDisplay2 = mergeTarget.CableDateDisplay;
            mergedItem.cableTagType2 = mergeTarget.cableTagType;
            mergedItem.cableConnected2 = mergeTarget.cableConnected;
          } else {
            mergedItem.stationName2 = "";
            mergedItem.stationTagType2 = "";
            mergedItem.stationConnected2 = "";

            mergedItem.SensorValueDateDisplay2 = "";
            mergedItem.sensorValueTagType2 = "";
            mergedItem.sensorValueConnected2 = "";

            mergedItem.SensorFlagDateDisplay2 = "";
            mergedItem.sensorFlagTagType2 = "";
            mergedItem.sensorFlagConnected2 = "";

            mergedItem.CableDateDisplay2 = "";
            mergedItem.cableTagType2 = "";
            mergedItem.cableConnected2 = "";
          }

          dataListMerged.push(mergedItem);
        }

        this.fullData = dataListMerged;
        this.totalCount = dataListMerged.length;

        this.getPageData();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.report-list {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;
  .table-command {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }
  .pagination {
    position: absolute;
    bottom: 0;
  }
}
.status-tag {
  cursor: pointer;
}
.table-button {
  margin-top: 5px;
  margin-left: 5px;
}

::v-deep .el-pagination {
  text-align: center;
}

.data-source-table {
  margin-top: -20px;
}

//隐藏合并列子列名
::v-deep .data-source-table thead tr:nth-child(2) {
  display: none;
}

//按分组设置背景色
::v-deep .data-source-table th:nth-child(2),
::v-deep .data-source-table th:nth-child(3),
::v-deep .data-source-table td:nth-child(2),
::v-deep .data-source-table td:nth-child(3),
::v-deep .data-source-table th:nth-child(10),
::v-deep .data-source-table th:nth-child(11),
::v-deep .data-source-table td:nth-child(10),
::v-deep .data-source-table td:nth-child(11) {
  background-color: #ecf5ff; /* 淡绿色底色 */
}

//hover颜色管理
//默认
::v-deep .data-source-table tbody tr:hover td {
  background-color: #f5f7fa;
}
//第一组
::v-deep.data-source-table tbody tr:hover td:nth-child(2),
::v-deep.data-source-table tbody tr:hover td:nth-child(3),
::v-deep.data-source-table tbody tr:hover td:nth-child(10),
::v-deep.data-source-table tbody tr:hover td:nth-child(11) {
  background-color: #d9ecff !important;
}

//略微降低行高
::v-deep.data-source-table td {
  padding: 11px 0;
}
</style>
